import { render, staticRenderFns } from "./ArrowsDecorator.vue?vue&type=template&id=1fc7c8c2&scoped=true&"
import script from "./ArrowsDecorator.vue?vue&type=script&lang=js&"
export * from "./ArrowsDecorator.vue?vue&type=script&lang=js&"
import style0 from "./ArrowsDecorator.vue?vue&type=style&index=0&id=1fc7c8c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc7c8c2",
  null
  
)

export default component.exports